import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Checkbox } from 'ui-components/components/checkbox/';
import { noop } from 'ui-components/default-props/noop';
import { Input } from 'ui-components/components/input';
import { FormattedMessagePropType } from '../../../../prop-types/intl';
import { b13ACanada } from '../../../../services/other-shipping-options/constants';

import style from './inputs.module.css';

const b13ALabel = <FormattedMessage defaultMessage='Authorization Code' description='otherShippingOptions.b13ALabel' id='Mp4zC4' />;

export const B13aCanada = ({ label, checked = false, onCheck = noop, optionData = '', updateOption = noop }) => {
  const [value, setValue] = useState(optionData);
  const onBlur = useCallback(() => {
    updateOption({ id: b13ACanada, value });
  }, [updateOption, value]);

  return (
    <div>
      <Checkbox checked={checked} label={label} onChange={onCheck} />
      {checked && (
        <div className={style['single-input']}>
          <Input label={b13ALabel} onBlur={onBlur} onChange={setValue} value={value} />
        </div>
      )}
    </div>
  );
};

B13aCanada.propTypes = {
  label: FormattedMessagePropType.isRequired,
  checked: PropTypes.bool,
  onCheck: PropTypes.func,
  optionData: PropTypes.string,
  updateOption: PropTypes.func,
};
